import type { MessageKey } from "./messages";
import { translate } from "./messages";

type ClerkErrorItem = {
  code?: string;
  longMessage?: string;
  message?: string;
};

const CLERK_ERROR_KEYS: Record<string, MessageKey> = {
  form_code_incorrect: "auth.clerkCodeIncorrect",
  form_password_incorrect: "auth.clerkPasswordIncorrect",
  form_identifier_not_found: "auth.clerkIdentifierNotFound",
};

function clerkErrors(err: unknown): ClerkErrorItem[] {
  if (!err || typeof err !== "object" || !("errors" in err)) {
    return [];
  }
  const errors = (err as { errors?: ClerkErrorItem[] }).errors;
  return Array.isArray(errors) ? errors : [];
}

/** Localize known Clerk Frontend API error codes; fall back to Clerk text. */
export function formatClerkErrorMessage(
  err: unknown,
  locale: string | null | undefined,
): string {
  const first = clerkErrors(err)[0];
  if (first?.code) {
    const key = CLERK_ERROR_KEYS[first.code];
    if (key) {
      return translate(key, locale);
    }
  }
  if (first?.longMessage?.trim()) {
    return first.longMessage.trim();
  }
  if (first?.message?.trim()) {
    return first.message.trim();
  }
  if (err instanceof Error && err.message.trim()) {
    return err.message.trim();
  }
  return translate("auth.clerkUnknownError", locale);
}

export function clerkErrorCode(err: unknown): string | undefined {
  return clerkErrors(err)[0]?.code;
}
